import {
  request
} from "./request";

export function getAllGenenameAndEnsemblID() {
  return request({
    url: '/ascancer/api/gencode/allgene/'
  })
}

export function getAllGeneNamesFromGeneInfo() {
  return request({
    url: '/ascancer/api/geneinfo/allgene/',
  })
}

export function getAllExpressionMedianByGenename(genename) {
  return request({
    url: '/ascancer/api/median/genename/',
    params: {
      genename
    }
  })
}

export function getIsoformPercentByGenename(genename) {
  return request({
    url: '/ascancer/api/isopct',
    params: {
      genename
    }
  })
}

export function getStatisticNumberFromSV() {
  return request({
    url: '/ascancer/api/sv/statistic',
  })
}